import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faDotCircle } from '@fortawesome/free-solid-svg-icons';
import Row from 'components/UI/Layout/Row';
import Button from 'components/UI/Button';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';
import Dialog from 'components/UI/Dialog';
import LoadingSpinner from 'components/UI/LoadingIndicators/LoadingSpinner';
import { connect } from 'react-redux';
import { deleteRequestQuoteComponent } from 'store/dispatchers/requestQuoteComponents.dispatchers';
import { buildMetaRequestQuoteSelector } from 'store/selectors/requestQuotes.selector';

function ComponentBox({
    children,
    subTitle,
    typeName, description,
    date,
    icon,
    showViewMore,
    summaryContent,
    metaRequest,
    requestQuoteComponentId,
    requestQuoteId,
    removeRequestComponent,
})
{
    const [extendedBox, setExtendedBox] = useState(false);
    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);

    const handledeleteRequestQuoteComponent = () =>
    {
        removeRequestComponent(requestQuoteId, requestQuoteComponentId).finally(() =>
        {
            setShowConfirmDeleteModal(false);
        });
    };

    return (
        <div>
            {!isEmpty(date) && (
                <div className="tw-text-xl tw-rounded tw-text-left tw-flex tw-items-center tw-relative">
                    <FontAwesomeIcon
                        className="tw-p-[8px] tw-text-primary-default tw-w-[16px] tw-h-[16px] tw-absolute tw-pl-0 -tw-left-1.5"
                        icon={faDotCircle}
                    />
                    <span className="tw-text-neutral-700 dark:tw-text-neutral-200 tw-ml-5">{date}</span>
                </div>
            )}

            <Dialog
                model={{ value: showConfirmDeleteModal, setter: setShowConfirmDeleteModal }}
                footer={(
                    <>
                        <button
                            onClick={handledeleteRequestQuoteComponent}
                            disabled={metaRequest.loading}
                            type="button"
                            className="tw-items-center tw-text-white tw-mt-3 tw-inline-flex tw-w-full tw-justify-center tw-rounded-md tw-border tw-bg-primary-default tw-px-4 tw-pt-2 tw-pb-1.5 tw-text-base tw-font-medium tw-shadow-sm hover:tw-bg-primary-hover focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500 focus:tw-ring-offset-2 sm:tw-mt-0 sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm"
                        >
                            Confirm <LoadingSpinner loading={metaRequest.loading ?? false} className="tw-ml-2 tw-mr-1" />
                        </button>
                        <button
                            onClick={() =>
                            {
                                setShowConfirmDeleteModal(false);
                            }}
                            type="button"
                            className="tw-mt-3 tw-inline-flex tw-w-full tw-justify-center tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-4 tw-pt-2 tw-pb-1.5 tw-items-center tw-text-base tw-font-medium tw-text-gray-700 tw-shadow-sm hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500 focus:tw-ring-offset-2 sm:tw-mt-0 sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm"
                        >
                            Close
                        </button>
                    </>
                )}
            >
                <div>
                    <h3 className="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900 dark:tw-text-gray-100">
                        Are you sure?
                    </h3>

                    <div className="tw-text-sm">
                        Do you really want to delete this record?
                    </div>
                </div>
            </Dialog>
            <div className="tw-inline-block tw-w-full tw-pl-5 tw-relative">
                <div className="tw-w-1 tw-h-full tw-absolute -tw-top-2 tw-left-0 tw-rounded-md tw-bg-primary-default tw-box-content tw-pb-8"></div>
                <p className="tw-leading-tight tw-text-justify tw-w-full">
                    {subTitle}
                </p>
                <Row className="tw-text-xl tw-mb-1 tw-mt-1 tw-px-3 tw-py-1 tw-w-full tw-bg-primary-default tw-rounded tw-font-semibold tw-text-white">
                    <div>
                        {icon
                            && <FontAwesomeIcon data-toggle="tooltip" className="tw-mr-2" icon={icon} />}
                    </div>
                    <Row className={`tw-w-full ${icon ? 'tw-relative' : ''}`}>
                        <div>
                            {typeName} - {description}
                        </div>
                        <div className="tw-ml-auto">
                            <Button icon={faTrashAlt} type="danger" margin="" iconMargin="tw-m-0" padding="tw-py-1 tw-px-2" onClick={() => setShowConfirmDeleteModal(true)} />
                        </div>
                    </Row>
                </Row>

                <div className={`${(showViewMore && !extendedBox) ? 'tw-max-h-[185px] tw-overflow-hidden' : ''} tw-transition-all`}>
                    {children}
                </div>

                {showViewMore && !extendedBox && (
                    <div className="tw-relative tw-top-[-30px] tw-z-[15] tw-w-full tw-text-center">
                        <div className="dark:tw-bg-zinc-700 tw-bg-gray-100 tw-opacity-90 hover:tw-opacity-100">
                            <button
                                type="button"
                                className="hover:tw-text-primary-hover tw-py-2 tw-px-2 tw-w-full tw-h-full"
                                onClick={() =>
                                {
                                    setExtendedBox(true);
                                }}
                            >
                                <div className="dark:tw-bg-zinc-700 tw-bg-gray-100 tw-opacity-90 hover:tw-opacity-100">
                                    <FontAwesomeIcon icon={faChevronDown} />
                                </div>
                                <b>View more</b>
                            </button>
                        </div>
                    </div>
                )}

                {showViewMore && extendedBox && (
                    <div className="tw-cursor-pointer tw-underline tw-text-primary-default dark:tw-bg-zinc-700 tw-bg-gray-100 tw-opacity-90 hover:tw-opacity-100 tw-mb-3">
                        <button
                            type="button"
                            className="hover:tw-text-primary-hover tw-py-2 tw-px-2 tw-w-full tw-h-full"
                            onClick={() =>
                            {
                                setExtendedBox(false);
                            }}
                        >
                            <b>View less</b>
                        </button>
                    </div>
                )}
                {summaryContent && (
                    <div className={`tw-py-2 tw-relative tw-rounded-b-md ${!extendedBox && showViewMore ? ' tw-top-[-28px]' : ' tw-top-[-10px]'}`}>
                        {summaryContent}
                    </div>
                )}
            </div>
        </div>
    );
}

ComponentBox.defaultProps = {
    summaryContent: '',
    subTitle: '',
    typeName: '',
    description: '',
    date: null,
    icon: null,
    showViewMore: false,
};

ComponentBox.propTypes = {
    requestQuoteComponentId: PropTypes.number,
    requestQuoteId: PropTypes.number,
    summaryContent: PropTypes.node,
    children: PropTypes.node.isRequired,
    subTitle: PropTypes.string,
    typeName: PropTypes.string,
    description: PropTypes.string,
    date: PropTypes.string,
    icon: PropTypes.object,
    showViewMore: PropTypes.bool,
    metaRequest: PropTypes.any,
    removeRequestComponent: PropTypes.func,
};

const mapStateToProps = () =>
{
    const metaRequestQuoteSelector = buildMetaRequestQuoteSelector();

    return (state, props) => ({
        metaRequest: metaRequestQuoteSelector(state, props.requestQuoteId),
    });
};

const mapDispatchToProps = (dispatch) => ({
    removeRequestComponent(requestQuoteId, requestQuoteComponentId)
    {
        return dispatch(deleteRequestQuoteComponent(requestQuoteId, requestQuoteComponentId));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ComponentBox);
